import { useState } from "react";
import { MapPin, Languages, Building2 } from "lucide-react";
import { useApi } from "../../lib/api";
import { SampleBadge, SourceTag } from "../Badges";
import { ApplyDialog } from "./ApplyDialog";

const ENT = ["", "Despite Music Production Ltd.", "U2 Company Limited", "Despite Digital Ltd.", "Neat Foods Company Ltd.", "Best Point Savings & Loans"];

export const JobBoard = () => {
  const [flt, setFlt] = useState({ q: "", entity: "", department: "", location: "", language: "" });
  const [job, setJob] = useState(null);
  const qs = new URLSearchParams(Object.entries(flt).filter(([, v]) => v)).toString();
  const { data } = useApi(`/public/jobs?${qs}`);
  const set = (k) => (e) => setFlt({ ...flt, [k]: e.target.value });
  return (
    <div data-testid="job-board">
      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-3 mb-6">
        <input className="field" placeholder="Search roles…" value={flt.q} onChange={set("q")} data-testid="job-search-input" />
        <select className="field" value={flt.entity} onChange={set("entity")} data-testid="job-filter-entity">{ENT.map((e) => <option key={e} value={e}>{e || "All entities"}</option>)}</select>
        <select className="field" value={flt.department} onChange={set("department")} data-testid="job-filter-department">
          {["", "Newsroom", "Production", "Digital", "Operations", "Finance", "Mining"].map((d) => <option key={d} value={d}>{d || "All departments"}</option>)}
        </select>
        <select className="field" value={flt.location} onChange={set("location")} data-testid="job-filter-location">{["", "Accra", "Kumasi"].map((d) => <option key={d} value={d}>{d || "All locations"}</option>)}</select>
        <select className="field" value={flt.language} onChange={set("language")} data-testid="job-filter-language">{["", "Twi", "English"].map((d) => <option key={d} value={d}>{d || "Any language"}</option>)}</select>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {(data || []).map((j) => (
          <div key={j.id} className="panel panel-hover p-5 flex flex-col gap-3" data-testid={`job-card-${j.id}`}>
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="eyebrow !text-[10px]">{j.brand}</div>
                <h3 className="text-lg text-ink font-semibold mt-1">{j.title}</h3>
              </div>
              {j.is_sample ? <SampleBadge label="Sample role" /> : <span className="pill pill-green">Public posting</span>}
            </div>
            <div className="flex flex-wrap gap-4 text-xs text-slate-400">
              <span className="flex items-center gap-1"><Building2 size={13} />{j.entity}</span>
              <span className="flex items-center gap-1"><MapPin size={13} />{j.location}</span>
              <span className="flex items-center gap-1"><Languages size={13} />{j.language}</span>
            </div>
            <p className="text-sm text-slate-400">{j.requirements}</p>
            <div className="flex items-center justify-between mt-auto pt-2">
              {j.source_url ? <SourceTag source={j.source} url={j.source_url} /> : <span className="text-[11px] text-slate-500">{j.department} · {j.type}</span>}
              {j.source_url ? (
                <a href={j.source_url} target="_blank" rel="noreferrer" className="btn-ghost" data-testid={`job-view-source-${j.id}`}>View advert</a>
              ) : (
                <button onClick={() => setJob(j)} className="btn-gold" data-testid={`job-apply-btn-${j.id}`}>Apply</button>
              )}
            </div>
          </div>
        ))}
        {data?.length === 0 && <div className="text-sm text-slate-500" data-testid="jobs-empty">No open roles match these filters. Join the talent community below.</div>}
      </div>
      <ApplyDialog job={job} onClose={() => setJob(null)} />
    </div>
  );
};
